import classNames from '@/utils/classNames';
import BaseButton from '@/components/Button/particles/BaseButton';
import ButtonIcon from '@/components/Button/particles/ButtonIcon';
import type { ButtonWithStaticIcon } from '@/components/Button/types';

const CLASSNAME =
  'bg-transparent focus-visible:outline-blue-600 shadow-none not-disabled:hover:shadow-none not-disabled:active:shadow-none';

type TextButtonProps = {
  variant?: 'danger' | 'normal' | 'info';
} & React.ComponentProps<typeof BaseButton>;

const TextButton = (({
  className,
  variant,
  ref,
  ...props
}: TextButtonProps) => (
  <BaseButton
    ref={ref}
    loadingLight
    {...props}
    className={classNames(
      CLASSNAME,
      {
        'not-disabled:text-greyscale-950 not-disabled:hover:text-blue-700 enabled:text-greyscale-950 disabled:text-greyscale-950/30':
          variant === 'normal',
        'not-disabled:text-red-500 not-disabled:hover:text-red-500 enabled:text-red-500 disabled:text-red-400':
          variant === 'danger',
        'not-disabled:text-blue-600 not-disabled:hover:text-blue-700 enabled:text-blue-600 disabled:text-blue-600/30':
          variant === 'info',
      },
      className,
    )}
  />
)) as ButtonWithStaticIcon;

TextButton.displayName = 'TextButton';

TextButton.Icon = ButtonIcon;

export default TextButton;
